
import React from 'react';

interface KeyBriefingProps {
    content: string;
    isWebtoon?: boolean;
}

export const KeyBriefing: React.FC<KeyBriefingProps> = ({ content, isWebtoon }) => {
    if (!content) return null;

    // 마침표나 줄바꿈을 기준으로 문장을 분리하여 요약 포인트 생성
    const points = content
        .split(/[.\n]/)
        .map(p => p.trim())
        .filter(p => p.length > 10) // 너무 짧은 문장은 제외
        .slice(0, 3); // 최대 3개 포인트

    if (points.length === 0) return null;

    return (
        <div className={`my-10 ${isWebtoon ? '' : 'border-l-[3px] border-slate-900 pl-6'} space-y-4 animate-in fade-in slide-in-from-left duration-700`}>
            {points.map((point, i) => (
                <div key={i} className="relative">
                    <p className={`${isWebtoon ? 'text-[14px] md:text-[15px] text-slate-600 italic font-medium normal-case' : 'text-[15px] md:text-[17px] font-black text-slate-800 uppercase tracking-tight'} leading-[1.6]`}>
                        {point}
                    </p>
                </div>
            ))}
        </div>
    );
};
